import { Option } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';
import { IFileTypeDtoFileTypeEnum } from '@/types';

export interface InputFile extends MediaSource {
  name: string;
  lastModified?: number;
  errorsCount?: number;
}

// TODO: replace by DTO
export enum FileStatus {
  Initiated = 'Initiated',
  Parsed = 'Parsed',
  Validated = 'Validated',
  Approved = 'Approved',
  QualityGateFailed = 'QualityGateFailed',

  Duplicate = 'Duplicate',
  Uploading = 'Uploading',
  Uploaded = 'Uploaded',
  Error = 'Error',
  Processing = 'Processing',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Rejected = 'Rejected',
  Unknown = 'Unknown',
}

export interface FileDto {
  id: string;
  name: string;
  partnersNames?: string[];
  employersNames?: string[];
  uploadedBy?: string;
  uploadWay: string;
  path: string;
  errorsCount?: number;
  originPath: string;
  approvalType: string;
  extensionType: string;
  type: string;
  processingType: string;
  status: FileStatus;
  createdAt: string;
  processedAt: string;
  isQualityGateError?: boolean;
}

export interface FileDtoWithMediaSource extends FileDto {
  file: InputFile;
  temporalId?: string;
  backlighting?: FileStatus;
  backlightingTime?: number;
  hasReuploading?: boolean;
}

export const FILE_TYPE_TITLES = {
  [IFileTypeDtoFileTypeEnum.CENSUS]: 'Census',
  [IFileTypeDtoFileTypeEnum.ENROLLMENT]: 'Enrollment',
  [IFileTypeDtoFileTypeEnum.CONTRIBUTION]: 'Contribution',
  [IFileTypeDtoFileTypeEnum.CARRIER]: 'Carrier',
  [IFileTypeDtoFileTypeEnum.DEPENDENT]: 'Dependent',
  [IFileTypeDtoFileTypeEnum.BALANCE_ADJUSTMENT]: 'Adjustment',
};
export const ADJUSTMENT_OPTION: Option = {
  key: IFileTypeDtoFileTypeEnum.BALANCE_ADJUSTMENT,
  value: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.BALANCE_ADJUSTMENT],
  title: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.BALANCE_ADJUSTMENT],
};
export const FILE_RECORD_TYPES_OPTIONS = [
  ALL_OPTION,
  {
    key: IFileTypeDtoFileTypeEnum.CENSUS,
    value: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.CENSUS],
    title: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.CENSUS],
  },
  {
    key: IFileTypeDtoFileTypeEnum.ENROLLMENT,
    value: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.ENROLLMENT],
    title: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.ENROLLMENT],
  },
  {
    key: IFileTypeDtoFileTypeEnum.CONTRIBUTION,
    value: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.CONTRIBUTION],
    title: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.CONTRIBUTION],
  },
  {
    key: IFileTypeDtoFileTypeEnum.CARRIER,
    value: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.CARRIER],
    title: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.CARRIER],
  },
  {
    key: IFileTypeDtoFileTypeEnum.DEPENDENT,
    value: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.DEPENDENT],
    title: FILE_TYPE_TITLES[IFileTypeDtoFileTypeEnum.DEPENDENT],
  },
  ADJUSTMENT_OPTION,
];

export const FILE_STATUS_OPTIONS = [
  ALL_OPTION,
  {
    key: FileStatus.Uploading,
    value: FileStatus.Uploading,
    title: FileStatus.Uploading,
  },
  {
    key: FileStatus.Uploaded,
    value: FileStatus.Uploaded,
    title: FileStatus.Uploaded,
  },
  {
    key: FileStatus.Duplicate,
    value: FileStatus.Duplicate,
    title: FileStatus.Duplicate,
  },
  {
    key: FileStatus.Error,
    value: FileStatus.Error,
    title: FileStatus.Error,
  },
  {
    key: FileStatus.Processing,
    value: FileStatus.Processing,
    title: FileStatus.Processing,
  },
  {
    key: FileStatus.Completed,
    value: FileStatus.Completed,
    title: FileStatus.Completed,
  },
  {
    key: FileStatus.Canceled,
    value: FileStatus.Canceled,
    title: FileStatus.Canceled,
  },
];
